module.exports = __webpack_public_path__ + "static/media/spit.4d78bc8a.png";